import React, { PureComponent, Fragment } from 'react';
import { Header } from 'semantic-ui-react';
import './Table.css';

export default class Table extends PureComponent {
  renderTableTitle = () => {
    const { title } = this.props;
    return (
      <Header className="header" as="h2">
        {title}
      </Header>
    );
  };

  renderTableHeader = () => {
    const { header } = this.props;
    const headerRow = header.map(head => <th key={head}>{head}</th>);
    return (
      <thead>
        <tr>{headerRow}</tr>
      </thead>
    );
  };

  renderTableBody = () => {
    const { body } = this.props;
    return (
      <tbody>{body.map((row, idx) => this.renderTableRow(row, idx))}</tbody>
    );
  };

  renderTableRow = (rowData, idx) => {
    const tableRow = rowData.map((data, colIdx) => (
      <td key={`td_${idx}_${colIdx}`}>{data}</td>
    ));
    return <tr key={`tr_${idx}`}>{tableRow}</tr>;
  };

  render() {
    const { title, header, body } = this.props;
    return (
      <Fragment>
        {title && this.renderTableTitle()}
        <table>
          {header && this.renderTableHeader()}
          {body && this.renderTableBody()}
        </table>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Table/index.js